import * as React from "react";
import styled from "styled-components";
import useHistory from "routing/useHistory";
import Routes from "security-app/routing/Routes";
import { Button } from "components/bootstrap";
const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`;
function AssetTabs({ assetType }) {
  const { push } = useHistory();
  return /* @__PURE__ */ React.createElement(TabsContainer, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: assetType === "machine" ? "primary" : "default",
      bsSize: "small",
      onClick: () => push(Routes.ASSETS.list("machine"))
    },
    "Machines"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: assetType === "user" ? "primary" : "default",
      bsSize: "small",
      onClick: () => push(Routes.ASSETS.list("user"))
    },
    "Users"
  ));
}
export default AssetTabs;
